import { useCallback } from 'react'
import { VIDEO_STAGE_ORDER, VideoStage } from '@ayub/shared'
import { useVideoColumn } from './hooks'
import type { DueFilter } from './hooks'
import { VideoKanbanColumn } from './VideoKanbanColumn'

interface VideoKanbanViewProps {
  searchTerm: string
  /** Tez filtr (`docs/03`: "Kechikkan/Bugun/To'lovga tayyor/Tekshirilmagan") — har ustunning
   * o'z so'roviga qo'shiladi, shunda mos kelmaydigan ustunlar tabiiy ravishda bo'sh chiqadi. */
  due: DueFilter | undefined
  onSelectVideo: (id: number) => void
}

/**
 * Videolar kanbani — `docs/03-app-flow.md` Sahifa 2, standart ko'rinish. 5 ta bosqich — soni
 * doim bir xil va o'zgarmas (`VIDEO_STAGE_ORDER`), shuning uchun hook'lar sikl ichida emas,
 * aniq chaqirilgan (React hook tartibi hech qachon o'zgarmaydi; xuddi `BloggerKanbanView`
 * naqshining o'zi).
 */
export function VideoKanbanView({ searchTerm, due, onSelectVideo }: VideoKanbanViewProps) {
  const moderationColumn = useVideoColumn(VideoStage.MODERATION, searchTerm, due)
  const postedColumn = useVideoColumn(VideoStage.POSTED, searchTerm, due)
  const checkingColumn = useVideoColumn(VideoStage.CHECKING, searchTerm, due)
  const paidColumn = useVideoColumn(VideoStage.PAID, searchTerm, due)
  const rejectedColumn = useVideoColumn(VideoStage.REJECTED, searchTerm, due)

  const columns = {
    [VideoStage.MODERATION]: moderationColumn,
    [VideoStage.POSTED]: postedColumn,
    [VideoStage.CHECKING]: checkingColumn,
    [VideoStage.PAID]: paidColumn,
    [VideoStage.REJECTED]: rejectedColumn,
  } as const

  const handleCardClick = useCallback((id: number) => onSelectVideo(id), [onSelectVideo])

  // "Bugun tekshirish" navbati bo'sh bo'lganda quvonchli xabar — faqat PM Tekshiruvda ustuni
  // uchun, chunki "Kechikkan"/"Bugun" tez filtrlari asosan shu ustunning tekshiruv muddatiga
  // tegishli (`docs/03`, "Bo'sh holatlar").
  const isDueQuickFilter = due === 'today' || due === 'overdue'

  return (
    <div className="flex snap-x snap-mandatory gap-3 overflow-x-auto pb-2 sm:snap-none">
      {VIDEO_STAGE_ORDER.map((stage) => {
        const column = columns[stage]
        return (
          <VideoKanbanColumn
            key={stage}
            stage={stage}
            items={column.items}
            total={column.total}
            isLoading={column.isLoading}
            isFetching={column.isFetching}
            error={column.error}
            hasMore={column.hasMore}
            celebratory={isDueQuickFilter && stage === VideoStage.CHECKING}
            onLoadMore={column.loadMore}
            onCardClick={handleCardClick}
          />
        )
      })}
    </div>
  )
}
